var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponButtonIcon = function SvgCouponButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 6.333V5.166m0 6.417v-1.167m0 6.417v-1.166m-1.4 4.666h12.134c1.96 0 2.94 0 3.689-.381a3.5 3.5 0 0 0 1.53-1.53c.38-.749.38-1.729.38-3.689V7.266c0-1.96 0-2.94-.38-3.688a3.5 3.5 0 0 0-1.53-1.53c-.75-.381-1.73-.381-3.69-.381H6.934c-1.96 0-2.94 0-3.689.381a3.5 3.5 0 0 0-1.53 1.53c-.38.748-.38 1.728-.38 3.688v7.467c0 1.96 0 2.94.38 3.69a3.5 3.5 0 0 0 1.53 1.529c.749.381 1.73.381 3.69.381Z",
    stroke: "#1DC483",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCouponButtonIcon;